import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => {
  return {
    marginLeftIcon: {
      marginLeft: -3
    },

    dividerMargin: {
      marginBlock: token.marginSM
    },

    footer: {
      paddingInline: token.paddingXS
    },

    textBold: {
      fontWeight: 500
    },

    colorSecondary: {
      color: token.colorTextSecondary
    }
  }
})
